export default {"src":"/_next/static/media/default-success.3f9953d8.svg","height":144,"width":202};